import React from "react";
import { ThemeProvider } from "styled-components";

import theme from "../themes/theme";

import SiteFooter from "./SiteFooter";

export const NounProjectFooter = () => {
    return (
        <ThemeProvider theme={theme}>
            <SiteFooter />
        </ThemeProvider>
    );
};

export default NounProjectFooter;
